// src/components/sections/RelatedItem.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay } from "swiper/modules";

import { CartProduct } from "../../assets/icons/icons";
import { useTranslation } from "react-i18next";

const API_BASE = "https://laravel-api.aj-mart.com";
const buildStorageUrl = (p = "") =>
  `${API_BASE}/storage/app/public/${String(p || "").replace(/^\/+/, "")}`;

export default function RelatedItem({ currentId, category }) {
  const { t, i18n } = useTranslation();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/products`);
        let list = res?.data?.products || res?.data?.data || [];

        // استبعاد نفس المنتج
        if (currentId != null) {
          list = list.filter((p) => String(p?.product_id) !== String(currentId));
        }
        // فلترة حسب التصنيف (إن وُجد)
        if (category) {
          const norm = String(category).toLowerCase();
          list = list.filter(
            (p) => String(p?.product_category || "").toLowerCase() === norm
          );
        }

        if (!cancelled) setProducts(list.slice(0, 12));
      } catch (e) {
        if (!cancelled) setProducts([]);
        console.error("RelatedItem fetch error:", e);
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, [currentId, category]);

  if (!products.length) return null;

  const getText = (ar, en) => (i18n.language === "ar" ? ar : en);

  return (
    <section className="pb-[40px]">
      <div className="container">
        <div className="direction-text-ar page-title mb-[20px]">
          {t("Related")} <span>{t("Products")}</span>
        </div>

        <Swiper
          modules={[Autoplay]}
          spaceBetween={20}
          slidesPerView={1}
          style={{ padding: "0 18px", direction: "ltr", height: "500px" }}
          loop={true}
          pagination={{
            clickable: true,
            renderBullet: (index, className) => {
              return `<span class="${className} custom-dot"></span>`;
            },
          }}
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          breakpoints={{
            640: { slidesPerView: 1.5 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 4 },
          }}
          className="h-[500px] px-[20px]"
        >
          {products.map((el) => {
            const name = getText(el.product_name_A, el.product_name_E) || "Product";
            const desc = getText(el.product_desc_A, el.product_desc_E) || "";
            const price = Number(el.product_price || 0);
            const discount = Number(el.product_price_discount || 0);
            const after = (price * (1 - discount / 100)).toFixed(2);
            const inStock = Number(el.product_stock_available) > 0;
            const inventoryClass = inStock ? "text-[#18AB00]" : "text-red-500";
            const img = el.product_main_img
              ? buildStorageUrl(el.product_main_img)
              : "https://placehold.co/300x300?text=No+Image";

            return (
              <SwiperSlide key={el.product_id}>
                <Link
                  to={`/product/${el.product_id}`}
                  className="flex flex-col h-auto bg-[#f6f6f6] w-[250px] overflow-hidden border-[1px] justify-between border-[#d1d1d1] rounded-[4px]"
                >
                  <div className="w-[250px] h-[250px] relative">
                    <div className="w-[250px] h-[250px] border-b-[1px] border-b-[#1485a6]">
                      <img
                        className="w-full h-full object-contain"
                        src={img}
                        alt={name}
                      />
                    </div>
                  </div>

                  <div className="p-[10px]">
                    <div className="font-15 text-[18px] font-bold text-center capitalize line-clamp-2">
                      {name}
                    </div>
                    <p className="font-10 direction-ar-rt text-[13px] text-[#666666] text-center">
                      {t(`${desc.length > 75 ? desc.substring(0, 75) + "..." : desc}`)}
                    </p>

                    <div className="font-14 flex items-center justify-center gap-[5px] text-center">
                      <span className={`font-bold ${inventoryClass}`}>
                        {after} <span>{t("JOD")}</span>
                      </span>
                      <span className="line-through">
                        {price} <span>{t("JOD")}</span>
                      </span>
                    </div>

                    <div className="font-12 text-center font-bold">
                      {t(inStock ? "In Stock" : "Out of Stock")}
                    </div>
                  </div>

                  <Link
                    to={`/product/${el.product_id}`}
                    className="bg-[#1485a6] flex p-1.5 items-center justify-center gap-1.5 text-white font-bold rounded-tl-[20px] rounded-tr-[20px] transition-opacity duration-300"
                  >
                    <CartProduct />
                    {t("Add To Cart")}
                  </Link>
                </Link>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
}
